import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ADD_ROUTE_NAME,
  ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_LIST_ROUTE_NAME,
  ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_CLICK_DOMAINS,
} from '@modules/general-settings/submodules/click-domains/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsClickDomainsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ROUTE_NAME,
      path: 'click_domains',

      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AdminGeneralSettingsClickDomainsPage',
      permission: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS.CLICKDOMAINS_SHOW,
    });

    router.addChildRoute(ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_LIST_ROUTE_NAME,
      path: '',
      permission: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS.CLICKDOMAINS_SHOW,

      component: () => import('@modules/general-settings/submodules/click-domains/pages/AdminGeneralSettingsClickDomainsPage/AdminGeneralSettingsClickDomainsPage.vue'),
    });

    router.addChildRoute(ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ADD_ROUTE_NAME,
      path: 'add',
      permission: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS.CLICKDOMAINS_SHOW,
      meta: {
        hideParentModuleWrapper: true,
      },

      component: () => import('@modules/general-settings/submodules/click-domains/pages/AdminGeneralSettingsClickDomainsAddPage/AdminGeneralSettingsClickDomainsAddPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_CLICK_DOMAINS, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_LIST_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS.CLICKDOMAINS_SHOW,
      id: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_LIST_ROUTE_NAME,
      order: 140,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_CLICK_DOMAINS, getTranslationKeys);
  }
}
